import { Logo1Icon } from '@blocksuite/icons/rc';
import clsx from 'clsx';
import type { FC } from 'react';
import { useEffect, useState } from 'react';

import { authHeaderWrapper } from './share.css';

export const AuthHeader: FC<{
  title: string;
  subTitle?: string;
  className?: string;
  logoUrl?: string | null;
}> = ({ title, subTitle, className, logoUrl }) => {
  const [logoFailed, setLogoFailed] = useState(false);
  const normalizedSubTitle =
    typeof subTitle === 'string' ? subTitle.trim() : undefined;

  useEffect(() => {
    setLogoFailed(false);
  }, [logoUrl]);

  return (
    <div className={clsx(authHeaderWrapper, className)}>
      <p className="title">
        {logoUrl && !logoFailed ? (
          <img
            className="logo"
            src={logoUrl}
            alt=""
            width={20}
            height={20}
            onError={() => setLogoFailed(true)}
          />
        ) : (
          <Logo1Icon className="logo" />
        )}
        {title}
      </p>
      {normalizedSubTitle ? (
        <p className="subtitle">{normalizedSubTitle}</p>
      ) : null}
    </div>
  );
};
